<template>
    <div class="mx-3">
        <!-- filter -->
        <v-row class="align-baseline">
            <v-col cols="3">
                <v-autocomplete
                    v-model="file"
                	:items="files"
                	item-value="id"
                	item-text="name"
                	label="الملف المالي"
                	multiple
                    outlined
                    dense
                    hide-details
                />
            </v-col>
            
            <v-col cols="auto" align-self="end">
                <bee-date-input
                    v-model="fromDate"
                    label="من تاريخ"
                    dense
                    hide-details
                    clearable
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY"
                    class="w-100"
                    input-type="month"
                    fit-inputs
                ></bee-date-input>
            </v-col>

            <v-col cols="auto" align-self="end">
                <bee-date-input
                    v-model="toDate"
                    label="إلى تاريخ"
                    dense
                    hide-details
                    clearable
                    prepend-icon="mdi-calendar"
                    user-menu-picker
                    input-format-order="DD-MM-YYYY"
                    class="w-100"
                    input-type="month"
                    fit-inputs
                ></bee-date-input>
            </v-col>

            <v-col cols="auto">
                <v-checkbox label="المجموع" hide-details />
            </v-col>

            <v-col cols="auto">
                <v-checkbox v-model="showLables" label="عرض القيم" hide-details />
            </v-col>

            <v-spacer />    
			<v-col cols="2" class="py-0 px-0 d-flex justify-center align-baseline">
				<v-btn
					type="submit"
					color="info-light-color white--text"
				>
					<v-icon size="20" class="me-1">mdi-magnify</v-icon>
					{{$t('buttons.search')}}
				</v-btn>
			</v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <bar-chart type="line" height="450" :series="series" :categories="period" :showLables="showLables"></bar-chart>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BarChart from '@/components/BarChart.vue'
import moment from 'moment'
export default {
    components: {
        BarChart
    },
    data() {
        return {
            files: ['Beetronix', 'Beetronix tax'],
            fromDate: '2022-2-02',
            toDate: '2023-2-05',
            series: [
				{
					name: 'Beetronix',
					data: [500, 1000, 1200, 750, 1200, 1120, 1001, 1100, 999, 1000, 1010, 1222, 1222]
				}
			],
            showLables: true
        }
    },
    computed: {
        period() {
            var startDate = moment(this.fromDate);
            var endDate = moment(this.toDate);
            var betweenMonths = [];
            if (startDate < endDate){
            var date = startDate.startOf('month');

            while (date < endDate.endOf('month')) {
                betweenMonths.push(date.format('MMM'));
                date.add(1,'month');
            }
            }
            return betweenMonths
        }
    },
    methods: {
        moment
    },
}
</script>

<style scoped>
.align-baseline {
    align-self: baseline
}
</style>